import script from "./templateFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./templateFilter.vue?vue&type=script&setup=true&lang=js"

import "./templateFilter.vue?vue&type=style&index=0&id=e4640bbc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4640bbc"]])

export default __exports__